import React from 'react';
import PropTypes from 'prop-types';

import { useMutation } from '@ubisend/pulse-hooks';
import {
  Flex,
  useNotification,
  LeftHalfLayout,
  RightHalfLayout,
  Label
} from '@ubisend/pulse-components';
import {
  MultiComposer,
  MultiComposerSettings,
  MultiComposerWidget,
  MultiComposerSubmitButton,
  MultiComposerLanguageSelect,
  ComposerContext,
  useMultiComposerReducer
} from '@ubisend/pulse-composer';

import Modal from '../../../Modal';
import ComposerWidget from '../../../ComposerWidget';
import { useBuilder } from '../../../../hooks/index';
import { updateStepResponses } from '../../../../api/index';
import { composers } from '../../../../../../subjects/index';

const EditResponse = ({ handleClose, node }) => {
  const { showSuccess } = useNotification();

  const { dispatch } = useBuilder();

  const composer = useMultiComposerReducer({
    responses: node.base.responses,
    subjects: composers
  });

  const { isPending, mutate } = useMutation({
    mutationFn: updateStepResponses,
    onSuccess: ({ data }) => {
      dispatch({
        type: 'SYNC_STEP_RESPONSES',
        stepId: node.id,
        newResponses: data.data
      });
      showSuccess('Successfully updated responses');
      handleClose();
    }
  });

  const handleSubmit = event => {
    event.preventDefault();

    if (composer.valid && !isPending) {
      mutate({
        stepId: node.id,
        responses: composer.form
      });
    }
  };

  return (
    <Modal
      header="Edit response"
      handleClose={handleClose}
      style={{ maxWidth: '100%', width: '80rem' }}>
      <form onSubmit={handleSubmit}>
        <Flex pad>
          <ComposerContext.Provider value={composer}>
            <LeftHalfLayout>
              <Flex between center mb>
                <Label mb={false}>Language</Label>
                <Flex>
                  <MultiComposerLanguageSelect />
                </Flex>
              </Flex>
              <MultiComposer />
              <Flex right xSpace>
                <MultiComposerSettings />
                <MultiComposerSubmitButton
                  type="submit"
                  disabled={isPending || !composer.valid}>
                  Save
                </MultiComposerSubmitButton>
              </Flex>
            </LeftHalfLayout>
            <RightHalfLayout>
              <Flex fat="true" middle>
                <MultiComposerWidget as={ComposerWidget} />
              </Flex>
            </RightHalfLayout>
          </ComposerContext.Provider>
        </Flex>
      </form>
    </Modal>
  );
};

EditResponse.propTypes = {
  handleClose: PropTypes.func.isRequired,
  node: PropTypes.shape({
    id: PropTypes.number.isRequired,
    base: PropTypes.shape({
      title: PropTypes.string.isRequired,
      sensitive: PropTypes.bool.isRequired,
      responses: PropTypes.array.isRequired
    }).isRequired
  }).isRequired
};

export default EditResponse;
